import Vue from "vue";
import ResourceService from "./resource.service";
class VehicleOperationsService extends ResourceService {
  static get resource() {
    return "vehicle-operations";
  }

  static getChecklist(tripId) {
    return this.get(`checklist/${tripId}`);
  }

  static checklistExists(tripId) {
    return this.get(`checklist/exists/${tripId}`);
  }

  static getMissingPartsItems() {
    const url = `${this.resource}/missing-parts-items`;
    return new Promise((resolve, reject) => {
      Vue.axios
        .get(url)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  static createMissingPartsItems(data) {
    const url = `${this.resource}/missing-parts-items`;

    return new Promise((resolve, reject) => {
      Vue.axios
        .post(url, data)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  static editMissingPartsItems(id, data) {
    const url = `${this.resource}/missing-parts-items/${id}`;

    return new Promise((resolve, reject) => {
      Vue.axios
        .patch(url, data)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  static deleteMissingPartsItems(id) {
    const url = `${this.resource}/missing-parts-items/${id}`;

    return new Promise((resolve, reject) => {
      Vue.axios
        .delete(url)
        .then(() => {
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  static createMissingPartsGropups(data) {
    const url = `${this.resource}/missing-parts-groups`;

    return new Promise((resolve, reject) => {
      Vue.axios
        .post(url, data)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  static editMissingPartsGroups(id, data) {
    const url = `${this.resource}/missing-parts-groups/${id}`;

    return new Promise((resolve, reject) => {
      Vue.axios
        .patch(url, data)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  static deleteMissingPartsGropups(id) {
    const url = `${this.resource}/missing-parts-groups/${id}`;

    return new Promise((resolve, reject) => {
      Vue.axios
        .delete(url)
        .then(() => {
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

}

export default VehicleOperationsService;
